import { Tag } from 'antd';
import React from 'react';

import { ProductGroupModel } from '@/typings/models/ProductGroup';

export default function ProductGroupTag({ productGroup }: { productGroup: ProductGroupModel }) {
  if (!productGroup) return null;

  return <Tag style={{fontSize: 10}} color={"lime"} bordered={false}>
    {productGroup?.label}
  </Tag>;
}
